import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Auth } from 'Pages/auth'
import { Callback } from 'Src/types/utilTypes'

export type ProfileState = {
	isEditing: boolean
	avatarEditorFile?: {
		name: string
		dataUrl: string
	}
}

export type ChangePasswordValues = {
	old_password: string
	password: string
	confirm_password: string
}

const initialState: ProfileState = {
	isEditing: false,
	avatarEditorFile: undefined,
}

export namespace ProfileNS {
	export type SetIsEditing = PayloadAction<boolean>
	export type SetAvatarEditFile = PayloadAction<{
		name: string
		dataUrl: string
	}>
	export type GetProfile = PayloadAction<{ id: number }>
	export type UpdateProfile = PayloadAction<Partial<Auth>>
	export type UpdatePassword = PayloadAction<{
		data: ChangePasswordValues
		errorCallback?: Callback
	}>
	export type UpdateUsername = PayloadAction<{ old_password: string; username: string }>
}

export const profileSlice = createSlice({
	name: 'profile',
	initialState,
	reducers: {
		getProfile: (state, action: ProfileNS.GetProfile) => {},
		updateProfile: (state, action: ProfileNS.UpdateProfile) => {},
		updatePassword: (state, action: ProfileNS.UpdatePassword) => {},
		updateUsername: (state, action: ProfileNS.UpdateUsername) => {},
		setIsEditing: (state, action: ProfileNS.SetIsEditing) => {
			state.isEditing = action.payload
		},
		setAvatarEditorFile: (state, action: ProfileNS.SetAvatarEditFile) => {
			state.avatarEditorFile = action.payload
		},
		clearAvatarEditorFile: (state) => {
			state.avatarEditorFile = undefined
		},
	},
})
